import { createZodDto } from "nestjs-zod/dto";
import z from "zod";

const createIpSchema = z.object({
  address: z.string().min(1),
  countryId: z.string().min(1),
});

export class CreateIpDto extends createZodDto(createIpSchema) {}
